var map = {
	"./1.svg": 5205,
	"./10.svg": 808,
	"./11.svg": 1818,
	"./12.svg": 8544,
	"./2.svg": 5189,
	"./3.svg": 1436,
	"./4.svg": 2822,
	"./5.svg": 8561,
	"./6.svg": 3335,
	"./7.svg": 3378,
	"./8.svg": 4363,
	"./9.svg": 5033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3623;